/*
 * @Descripttion: 订单管理
 * @Author: DXV-RGWU-TUFH-RFCY-IEGMYY
 * @Date: 2020-07-06 12:17:06
 * @LastEditors: DXV-RGWU-TUFH-RFCY-IEGMYY
 * @LastEditTime: 2024-01-19 10:54:42
 */
import {
  get,
  post
} from '../index'
export default {
  // 查看客户标签
  userLabelList (querys) {
    return get('massage/admin/AdminCoach/userLabelList', querys)
  },
  // 订单管理
  orderList (querys) {
    return get('massage/admin/AdminOrder/orderList', querys)
  },
  // 订单详情
  orderInfo (querys) {
    return get('massage/admin/AdminOrder/orderInfo', querys)
  },
  // 可退款服务详情
  canRefundOrderInfo (querys) {
    return get('massage/admin/AdminOrder/canRefundOrderInfo', querys)
  },
  // 订单升级记录
  orderUpRecord (querys) {
    return get('massage/admin/AdminOrder/orderUpRecord', querys)
  },
  // 技-师轨迹
  coachTrajectory (querys) {
    return get('massage/admin/AdminOrder/coachTrajectory', querys)
  },
  // 订单记录
  orderControlRecord (querys) {
    return get('massage/admin/AdminOrder/orderControlRecord', querys)
  },
  // 退款管理
  refundOrderList (querys) {
    return get('massage/admin/AdminOrder/refundOrderList', querys)
  },
  // 退款详情
  refundOrderInfo (querys) {
    return get('massage/admin/AdminOrder/refundOrderInfo', querys)
  },
  // 通知列表
  noticeList (querys) {
    return get('massage/admin/AdminOrder/noticeList', querys)
  },
  // 通知详情
  noticeInfo (querys) {
    return get('massage/admin/AdminOrder/noticeInfo', querys)
  },
  // 编辑通知状态
  noticeUpdate (querys) {
    return post('massage/admin/AdminOrder/noticeUpdate', querys)
  },
  // 未查看的数量
  noLookCount (querys) {
    return post('massage/admin/AdminOrder/noLookCount', querys)
  },
  // 全部已读
  allLook (querys) {
    return post('massage/admin/AdminOrder/allLook', querys)
  },
  // 同意退款
  passRefund (querys) {
    return post('massage/admin/AdminOrder/passRefund', querys)
  },
  // 拒绝退款
  noPassRefund (querys) {
    return post('massage/admin/AdminOrder/noPassRefund', querys)
  },
  // 评价标签列表
  commentLableList (querys) {
    return get('massage/admin/AdminOrder/commentLableList', querys)
  },
  // 评价标签详情
  commentLableInfo (querys) {
    return get('massage/admin/AdminOrder/commentLableInfo', querys)
  },
  // 新增评价标签
  commentLableAdd (querys) {
    return post('massage/admin/AdminOrder/commentLableAdd', querys)
  },
  // 编辑评价标签
  commentLableUpdate (querys) {
    return post('massage/admin/AdminOrder/commentLableUpdate', querys)
  },
  // 评价列表
  commentList (querys) {
    return get('massage/admin/AdminOrder/commentList', querys)
  },
  // 编辑评价
  commentUpdate (querys) {
    return post('massage/admin/AdminOrder/commentUpdate', querys)
  },
  // 标签列表
  lableList (querys) {
    return get('massage/admin/AdminOrder/lableList', querys)
  },
  // 新增虚拟评价
  addComment (querys) {
    return post('massage/admin/AdminOrder/addComment', querys)
  },
  // 佣金记录
  commList (querys) {
    return post('massage/admin/AdminUser/commList', querys)
  },
  // 技-师转账
  adminUpdateCoachCommisson (querys) {
    return post('massage/admin/AdminUser/adminUpdateCoachCommisson', querys)
  },
  // 立即退款/完成订单
  adminUpdateOrder (querys) {
    return post('massage/admin/AdminOrder/adminUpdateOrder', querys)
  },
  // 转派技-师可选列表
  orderChangeCoachList (querys) {
    return get('massage/admin/AdminOrder/orderChangeCoachList', querys)
  },
  // 转派技-师
  orderChangeCoach (querys) {
    return post('massage/admin/AdminOrder/orderChangeCoach', querys)
  },
  // 平台发起退款
  applyOrderRefund (querys) {
    return post('massage/admin/AdminOrder/applyOrderRefund', querys)
  },
  // 同意退款
  passRefundV2 (querys) {
    return post('massage/admin/AdminOrder/passRefundV2', querys)
  },
  // 标记异常
  orderAdd (querys) {
    return post('abnormalorder/admin/AdminOrder/orderAdd', querys)
  },
  // 编辑标记异常
  updateOrder (querys) {
    return post('abnormalorder/admin/AdminOrder/updateOrder', querys)
  },
  // 待处理异常订单
  pendingOrderList (querys) {
    return get('abnormalorder/admin/AdminOrder/pendingOrderList', querys)
  },
  // 已处理异常订单
  alreadyOrderList (querys) {
    return get('abnormalorder/admin/AdminOrder/alreadyOrderList', querys)
  },
  // 异常订单详情
  abnormalOrderInfo (querys) {
    return get('abnormalorder/admin/AdminOrder/orderInfo', querys)
  },
  // 处理流程
  handleOrder (querys) {
    return post('abnormalorder/admin/AdminOrder/handleOrder', querys)
  },
  // 获取标记节点人
  getProcessStartInfo (querys) {
    return get('abnormalorder/admin/AdminProcess/getProcessStartInfo', querys)
  },
  // 新增/编辑流程
  processList (querys) {
    return get('abnormalorder/admin/AdminProcess/processList', querys)
  },
  // 新增/编辑流程
  processAdd (querys) {
    return post('abnormalorder/admin/AdminProcess/processAdd', querys)
  },
  // 停用流程
  stopProcess (querys) {
    return post('abnormalorder/admin/AdminProcess/stopProcess', querys)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/shop.js